import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { ArticleId } from '../../library/CMS';
import * as actions from './actions';

export const currentArticleIdReducer = reducerWithInitialState<ArticleId | null>(
  null,
).case(actions.setCurrentArticleId, (state, articleId) => articleId);
